import React, { useContext } from 'react';
import { QuickLinks as QuickLinksComponent } from '@thd-olt-component-react/quick-links';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { ImpressionProvider } from '@thd-olt-component-react/impression';
import proptypes from 'prop-types';
import { HomepageContext } from './context';
import { CUSTOMER_TYPES } from '../utils';

const { arrayOf, shape, string } = proptypes;

const B2C_QUICK_LINKS_LABEL = { desktop: 'Shop Popular Categories', mobile: 'Shop Popular' };

export function QuickLinks({ id, linkList, theme }) {
  const { customerType } = useContext(HomepageContext);
  const isB2C = customerType === CUSTOMER_TYPES.B2C || customerType === CUSTOMER_TYPES.GUEST;
  const label = isB2C && linkList?.length ? B2C_QUICK_LINKS_LABEL : undefined;

  const data = {
    name: 'QuickLinks',
    component: 'QuickLinks',
    type: 'content',
    position: 1,
    id
  };

  return (
    <ErrorBoundary name="quick-links">
      <QueryProvider cacheKey="quick-links-cacheKey">
        <ImpressionProvider data={data}>
          <QuickLinksComponent
            componentId={id}
            linkList={linkList}
            theme={theme}
            label={label}
            disablePadding={isB2C}
          />
        </ImpressionProvider>
      </QueryProvider>
    </ErrorBoundary>
  );
}

QuickLinks.propTypes = {
  id: string,
  linkList: arrayOf(shape({
    id: string,
    href: string,
    label: string,
  })),
  theme: string,
};

QuickLinks.defaultProps = {
  id: '',
  linkList: undefined,
  theme: undefined
};
